<template>
  <div class="flex min-h-screen">
    <Sidebar
      class="w-0 md:w-64 fixed h-full bg-gray-800 hidden md:block"
      @updatePage="changePage"
    />
    <div class="ml-0 flex-1 p-4">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script>
import Dashboard from '@/components/dashboard/Dashboard.vue'
import BusinessManagement from '@/components/dashboard/management/BusinessManagement.vue'
import ControlManagement from '@/components/dashboard/management/ControlManagement.vue'
import QuestionManagement from '@/components/dashboard/management/QuestionManagement.vue'
import UserManagement from '@/components/dashboard/management/UserManagement.vue'
import Maturity from '@/components/dashboard/domains/Maturity.vue'
import Organizational from '@/components/dashboard/domains/Organizational.vue'
import People from '@/components/dashboard/domains/People.vue'
import Physical from '@/components/dashboard/domains/Physical.vue'
import Technological from '@/components/dashboard/domains/Technological.vue'
import Sidebar from '@/components/layout/Sidebar.vue'
import { computed, ref } from 'vue'

export default {
  components: {
    Sidebar,
    Dashboard,
    Maturity,
    Organizational,
    People,
    Physical,
    Technological,
    UserManagement,
    ControlManagement,
    BusinessManagement,
    QuestionManagement,
  },
  setup() {
    const currentPage = ref('dashboard')

    const currentComponent = computed(() => {
      const componentsMap = {
        dashboard: Dashboard,
        maturity: Maturity,
        organizational: Organizational,
        people: People,
        physical: Physical,
        technological: Technological,
        userManagement: UserManagement,
        controlManagement: ControlManagement,
        businessManagement: BusinessManagement,
        questionManagement: QuestionManagement,
      }
      return componentsMap[currentPage.value] || Dashboard
    })

    const changePage = (page) => {
      currentPage.value = page
    }

    return { currentPage, currentComponent, changePage }
  },
}
</script>
